import React from "react";
import { classnames, Button, Icon } from "@culturehq/components";

import { useDelayedCallback } from "app/hooks";
import { t, Trans } from "app/utils";
import { useProfile } from "app/context";
import ChqModalConfirm from "components/common/ChqModalConfirm";

const KeepAsInternalButton = ({ story, onClick }) => {
  const [processed, onProcess] = useDelayedCallback(2000, () => onClick(story));
  const { profile } = useProfile();

  if (story.question.status === "hidden") {
    return (
      <ChqModalConfirm
        accept={t(profile.organization.storiesNeedApprovalEnabled ? "Approve for Internal" : "Keep as Internal")}
        onAccept={onProcess}
        trigger={onTrigger => (
          <span className={classnames("keep-internal", { "keep-internal-anim": processed })}>
            <Button inverted primary onClick={onTrigger}>
              <Icon icon="folder" />
              {profile.organization.storiesNeedApprovalEnabled ? (
                <Trans>Approve for Internal</Trans>
              ) : (<Trans>Keep as Internal</Trans>)}
            </Button>
            {processed && (
              <>
                <span className="keep-internal--circle" />
                <span className="keep-internal--check-white">
                  <span className="legend">
                    <Icon icon="checkmark" /><Trans>Done</Trans>
                  </span>
                </span>
              </>
            )}
          </span>
        )}
      >
        <Trans>
          By changing the story status, this story is going to be visible in the prompt page
        </Trans>
      </ChqModalConfirm>
    );
  }

  return (
    <span className={classnames("keep-internal", { "keep-internal-anim": processed })}>
      <Button inverted primary onClick={onProcess}>
        <Icon icon="folder" />
        {profile.organization.storiesNeedApprovalEnabled ? (
          <Trans>Approve for Internal</Trans>
        ) : (<Trans>Keep as Internal</Trans>)}
      </Button>
      {processed && (
        <>
          <span className="keep-internal--circle" />
          <span className="keep-internal--check-white">
            <span className="legend">
              <Icon icon="checkmark" /><Trans>Done</Trans>
            </span>
          </span>
        </>
      )}
    </span>
  );
};

export default KeepAsInternalButton;
